module.exports = __webpack_public_path__ + "static/media/teatro-municipale.9953478e.svg";